import React from 'react';
import GeneralModal from '../../../../components/GeneralModal/GeneralModal';
import { useDeleteEquipmentMutation } from '../../../../store/builder/inspections.api';
import { toast } from 'react-toastify';
import { useTranslation } from '../../../../hooks/useTranslation';

const DeleteToolModal = ({ toolId, setIsOpen, onDeleteSuccess }) => {
  const {t} = useTranslation();
  const [
    deleteEquipment,
    { isLoading: deleteIsLoading },
  ] = useDeleteEquipmentMutation();

  const handleDelete = () => {
    deleteEquipment(toolId).then((res) => {
      if (res?.data?.message) {
        toast.success(res?.data?.message);
      }
      if (res?.error) {
        toast.error(res?.error?.data?.message);
      }
      setIsOpen(false);
      if (onDeleteSuccess) {
        onDeleteSuccess();
      }
    });
  };

  return (
    <GeneralModal
      title=""
      onClose={() => setIsOpen(false)}
      onSubmit={handleDelete}
      submitTitle={t('toolsManagement.modals.buttons.delete')}
      cancelTitle={t('toolsManagement.modals.buttons.close')}
      btnType='delete'
      disableSubmit={deleteIsLoading}
    >
      <div
        className='modal__content-body'
        style={{display: 'flex', justifyContent: 'center'}}
      >
        <p className='modal__content-dangerText'>
          {t('toolsManagement.modals.delete.message')}
          <br />
          {t('toolsManagement.modals.delete.warning')}
        </p>
      </div>
    </GeneralModal>
  );
};

export default DeleteToolModal;

